import { Flex } from 'foundations-components/components/Flex';
import ActivityButtonSkeleton from './skeleton/ActivityButtonSkeleton';
import { useEffect, useRef, useState } from 'react';
import { LG, MD, SM } from 'crm-activity-creator-data/types/ActivityButtonProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MIN_LG_BUTTON_CONTAINER_WIDTH = 384;
const MIN_MD_BUTTON_CONTAINER_WIDTH = 300;
const CreateActivityButtonsSkeleton = ({
  buttonSize: buttonSizeProp
}) => {
  const [buttonSize, setButtonSize] = useState(buttonSizeProp);
  const containerRef = useRef(null);
  useEffect(() => {
    var _containerRef$current;
    if (buttonSizeProp) {
      setButtonSize(buttonSizeProp);
      return;
    }
    const containerWidth = ((_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 ? void 0 : _containerRef$current.offsetWidth) || 0;
    if (containerWidth >= MIN_LG_BUTTON_CONTAINER_WIDTH) {
      setButtonSize(LG);
    } else if (containerWidth >= MIN_MD_BUTTON_CONTAINER_WIDTH) {
      setButtonSize(MD);
    } else {
      setButtonSize(SM);
    }
  }, [buttonSizeProp]);
  return /*#__PURE__*/_jsx("div", {
    ref: containerRef,
    "data-test-id": "create-activity-buttons-skeleton",
    children: /*#__PURE__*/_jsx(Flex, {
      justifyContent: "center",
      paddingBlockStart: "200",
      paddingBlockEnd: "100",
      as: "ul",
      listStyleType: "none",
      children: buttonSize && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(ActivityButtonSkeleton, {
          size: buttonSize
        }), /*#__PURE__*/_jsx(ActivityButtonSkeleton, {
          size: buttonSize
        }), /*#__PURE__*/_jsx(ActivityButtonSkeleton, {
          size: buttonSize
        }), /*#__PURE__*/_jsx(ActivityButtonSkeleton, {
          size: buttonSize
        }), /*#__PURE__*/_jsx(ActivityButtonSkeleton, {
          size: buttonSize
        }), /*#__PURE__*/_jsx(ActivityButtonSkeleton, {
          size: buttonSize
        })]
      })
    })
  });
};
export default CreateActivityButtonsSkeleton;